import { render, staticRenderFns } from "./lots-prize-card.vue?vue&type=template&id=7f7e4daf&scoped=true&"
import script from "./lots-prize-card.vue?vue&type=script&lang=js&"
export * from "./lots-prize-card.vue?vue&type=script&lang=js&"
import style0 from "./lots-prize-card.vue?vue&type=style&index=0&id=7f7e4daf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e4daf",
  null
  
)

export default component.exports